import React from 'react';
import { Link } from 'react-router-dom';
import { Input } from 'reactstrap';
import Swal from 'sweetalert2';
import SAMFooter from '../../Layout/SAMFooter';
import { login } from '../../../config/AuthLogin';

import './login.css';
// Validaciones
import { ErrorMessage, withFormik } from 'formik';
import * as Yup from 'yup';
import {
    ERROR_LOGIN_LABEL,
    FORGOT_PASSWORD_LABEL,
    LOGIN_LABEL,
    PASSWORD_PLACEHOLDER,
    PASSWORD_REQUIRED_MESSAGE,
    REMEMBER_LABEL,
    USER_MAX_LENGTH_MESSAGE,
    USER_PLACEHOLDER,
    USER_REQUIRED_MESSAGE,
    WELCOME_LABEL,
} from '../../../constants/login';
import { useDispatch } from 'react-redux';
import { MaterialRequestPendingList, UserRolesList } from '../../../store/actions/actions';

require('dotenv').config();

export default function Login(props) {
    const dataForm = { user_name: '', password: '' };
    let authenticated = false;

    const dispatch = useDispatch();

    const verifyLogin = async (data) => {
        const user = await login(data).catch((err) =>
            Swal.fire({
                icon: 'error',
                title: ERROR_LOGIN_LABEL,
                text: err,
            }),
        );
        if (user.ok) {
            dispatch(MaterialRequestPendingList());  
            dispatch(UserRolesList());
            props.history.push('/home');
        } else if (user.error) {
            await Swal.fire({
                icon: 'error',
                title: ERROR_LOGIN_LABEL,
                text: user.error,
            });
        } else if (user.message) {
            await Swal.fire({
                icon: 'error',
                title: ERROR_LOGIN_LABEL,
                text: user.message,
            });
        }
    };

    // Metodo para validar formulario de Login
    const formikValidation = withFormik({
        validationSchema: Yup.object().shape({
            user_name: Yup.string()
                .required(USER_REQUIRED_MESSAGE)
                .max(20, USER_MAX_LENGTH_MESSAGE),
            password: Yup.string().required(PASSWORD_REQUIRED_MESSAGE),
        }),
        mapPropsToValues: (propiedades) => ({
            user_name: dataForm.user_name,
            password: dataForm.password,
        }),
        handleSubmit: (values, { setSubmitting }) => {
            const payload = {
                ...values,
            };
            verifyLogin({
                user_name: payload.user_name,
                password: payload.password,
            }).then();
            setSubmitting(false);
        },
        displayName: 'LoginForm',
    });

    const formData = (propiedades) => {
        const { values, touched, errors, handleChange, handleBlur, handleSubmit } = propiedades;
        return (
            <div className="">
                {/* <div className="block-center mt-2 wd-xl"> */}
                <div className="block-center mt-2 wd-xl">
                    <div className="card card-flat">
                        <div className="card-header text-center">
                            <a href="">
                                <img
                                    className="block-center rounded"
                                    src="img/logo-base.png"
                                    width="80%"
                                    height="80%"
                                    alt="Logo"
                                />
                            </a>
                        </div>
                        <div className="card-body">
                            <p className="text-center py-2">{WELCOME_LABEL}</p>
                            <form className="mb-3" name="formLogin" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <div className="input-group with-focus">
                                        <Input
                                            type="text"
                                            name="user_name"
                                            className="border-right-0"
                                            placeholder={USER_PLACEHOLDER}
                                            value={values.user_name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text text-muted bg-transparent border-left-0">
                                                <em className="fa fa-envelope" />
                                            </span>
                                        </div>
                                    </div>
                                    {!!errors.user_name && touched.user_name && (
                                        <div style={{ color: 'red', marginTop: '.5rem' }}>
                                            <ErrorMessage name="user_name" />
                                        </div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <div className="input-group with-focus">
                                        <Input
                                            type="password"
                                            name="password"
                                            className="border-right-0"
                                            placeholder={PASSWORD_PLACEHOLDER}
                                            value={values.password}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text text-muted bg-transparent border-left-0">
                                                <em className="fa fa-lock" />
                                            </span>
                                        </div>
                                    </div>
                                    {!!errors.password && touched.password && (
                                        <div style={{ color: 'red', marginTop: '.5rem' }}>
                                            <ErrorMessage name="password" />
                                        </div>
                                    )}
                                </div>
                                <div className="clearfix">
                                    <div className="checkbox c-checkbox float-left mt-0">
                                        <label>
                                            <input type="checkbox" value="" name="remember" />
                                            <span className="fa fa-check" />
                                            {REMEMBER_LABEL}
                                        </label>
                                    </div>
                                    <div className="float-right">
                                        <Link to="recover" className="text-muted">
                                            {FORGOT_PASSWORD_LABEL}
                                        </Link>
                                    </div>
                                </div>
                                <button className="btn btn-block btn-inverse mt-3" type="submit">
                                    {LOGIN_LABEL}
                                </button>
                            </form>
                        </div>
                    </div>
                    <SAMFooter />
                </div>
            </div>
        );
    };

    // eslint-disable-next-line no-unused-vars
    const SAMForm = formikValidation(formData);

    return <SAMForm />;
}
